<template>
  <q-table class="shadow-0 table bg-white mb-0" bordered :rows="filteredHistoriesStep" row-key="taskId"
    :rows-per-page-options="[filteredHistoriesStep?.length]" hide-pagination>
    <template v-slot:header="props">
      <q-tr :props="props">
        <q-th auto-width />
        <q-th>
          {{ $t("task.historiesStep.headers.action") }}
        </q-th>
        <q-th>
          {{ $t("task.historiesStep.headers.creationDate") }}
        </q-th>

        <q-th>
          {{ $t("task.historiesStep.headers.status") }}
        </q-th>

        <q-th>
          {{ $t("task.historiesStep.headers.date") }}
        </q-th>

        <q-th>
          {{ $t("task.historiesStep.headers.owner") }}
        </q-th>
        <q-th>
          {{ $t("task.historiesStep.headers.variables.variables") }}
        </q-th>
      </q-tr>
    </template>

    <template v-slot:body="props">
      <q-tr :props="props">
        <q-td auto-width>
        </q-td>
        <q-td> {{ `${$t(`task.actions.${props.row.taskDefinition}`)} ` }}</q-td>
        <q-td> {{ getDateFormated(`${props.row.creationDate || ""} `) }}</q-td>
        <q-td> {{ getDisplayStatus(props.row) }} </q-td>
        <q-td> {{ props.row.endDate ? getDateFormated(`${props.row.endDate || ""} `) : "-"  }}</q-td>
        <q-td>{{ getName(`${props.row.assignee || ""} `) }}</q-td>
        <q-td auto-width>
          <q-btn class="btn btn-sm btn-primary" size="sm" color="accent" round dense @click="openStatusHistory(props.row)"
            icon="visibility" />
        </q-td>

      </q-tr>
      <q-tr v-show="props.expand" :props="props" class="tw-expanded-table-row">
        <q-td colspan="100%">
          <div class="card-body p-0">
            <OrderHistoriesPanel :histories="props.row.histories" />
          </div>
        </q-td>
      </q-tr>
    </template>
    <template v-slot:no-data="{ icon, message, filter }">
        <div class="font-size-12 font-medium">
          <span> {{ $t("task.historiesStep.headers.histories.noDataMessage") }} </span>
        </div>
      </template>
  </q-table>

  <div>
    <StatusOrderHistory />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import OrderHistoriesPanel from "@/components/order/history/OrderHistoryPanel.vue";
import StatusOrderHistory from "@/components/order/history/StatusOrderHistory.vue";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import store from "@/store";
import moment from "moment";
import { OrderStatusHistoryVariables } from "@/types";



@Options({
  components: { OrderHistoriesPanel, LabelAndValue, StatusOrderHistory },
  props: ["historiesStep"],
})

export default class OrderHistory extends Vue {
  opened = false;
  historiesStep?: any[];

  get filteredHistoriesStep() {
    return this.historiesStep?.filter(row => row.status === 'completed') || [];
  }

  getDateFormated(date: any) {
    if (date && date !== "") return moment(date).format("DD/MM/YYYY HH:mm");
  }
  getDisplayStatus(row: any) {
    if (row.variables) {
        const vars = JSON.parse(row.variables);
        if (vars.startOrderDecision && vars.startOrderDecision.value) {
          const decision = vars.startOrderDecision.value;
          return this.$t(`task.historiesStep.headers.histories.${decision}`);
        }
    }
    return row.status ? this.$t(`task.historiesStep.headers.histories.${row.status}`) : "-";
  }
  getName(value: string) {
    if (value && value !== "") {
      return value.split("##")[0];
    }
  }

  openStatusHistory(row: any) {
    store.dispatch("orderModule/setOrderVariablesVisible", true);
    console.table(row.variables)

    if (typeof row.variables === 'string') {
      const obj = JSON.parse(row.variables);
      const variablesSelected: OrderStatusHistoryVariables = {
        orderReference: obj.orderReference ? obj.orderReference.value:'',
        orderStatus: obj.orderStatus ? obj.orderStatus.value:'',
        customerType: obj.customerType ? obj.customerType.value:'',
        customerName: obj.customerName? obj.customerName.value:'',
        initialDeliveryDate: obj.order && obj.order.initialDeliveryDate ? obj.order.initialDeliveryDate.value:'',
        provisionalDeliveryDate: obj.order && obj.order.initialDeliveryDate ? obj.order.provisionalDeliveryDate.value:'',
        orderItemCancellationDate: obj.orderItemCancellationDate ? obj.orderItemCancellationDate.value :'',
        taskDefinition: row.taskDefinition,
        comment : obj.comment && obj.comment.value ? obj.comment.value : ''
      }

      store.dispatch("orderModule/setOrderStatusHistoryVariablesSelected", variablesSelected);
    }

  }

  created() {
    store.dispatch("orderModule/getOrderHistory");
  }

}
</script>
